import React from 'react';
import { navigate, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  fontWeights,
  fontSize,
  standardTransition,
} from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';

// moved up for hover
const StyledImage = styled(GatsbyImage)`
  height: 100%;
  transition: ${standardTransition('transform')};
`;

const StyledProductCategoryCard = styled.article`
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    ${StyledImage} {
      transform: scale(1.1);
    }
  }
`;

const StyledContent = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  background-color: ${standardColours.transparentBlack(0.4)};
`;

const StyledHeading = styled.h3`
  color: ${standardColours.white};
  font-weight: ${fontWeights.semibold};
  ${fontSize(24)};
  line-height: 1.2;
  text-align: center;

  ${minBreakpointQuery.small`
    ${fontSize(27)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(30)};
  `}
`;

const ProductCategoryCard = ({ image, heading, page, ...props }) => (
  <StyledProductCategoryCard
    onClick={() => navigate(buildUrl(page.slug, page))}
    {...props}
  >
    <StyledImage image={image.gatsbyImageData} alt={image.alt} />
    <StyledContent>
      <StyledHeading>
        <Link to={page}>{heading}</Link>
      </StyledHeading>
    </StyledContent>
  </StyledProductCategoryCard>
);

export default ProductCategoryCard;

export const ProductCategoryCardFragment = graphql`
  fragment ProductCategoryCardFragment on DatoCmsProductCategory {
    id
    title
    featuredImage {
      gatsbyImageData(width: 710, height: 410)
      alt
    }
    ...LinkFragment
  }
`;
